/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-16 08:44:20
 *
 *******************************************************/
//flow

import type {
  SendSupportTicketState,
  SendSupportTicketAction
} from 'stores/flow-type/support-ticket.type';

import {
  SEND_SUPPORT_TICKET_REQUEST,
  SEND_SUPPORT_TICKET_SUCCESS,
  SEND_SUPPORT_TICKET_FAILURE,
  RESET_SEND_SUPPORT_TICKET
} from 'stores/flow-type/support-ticket.type';

const initialState: SendSupportTicketState = {
  sendSupportTicketLoading: false,
  sendSupportTicketSuccess: false,
  error: undefined,
  code: 0,
  status: ''
};

const supportTicketReducers = (
  state: SendSupportTicketState = initialState,
  action: SendSupportTicketAction
) => {
  switch (action.type) {
    case SEND_SUPPORT_TICKET_REQUEST:
      return { ...state, sendSupportTicketLoading: true };
    case SEND_SUPPORT_TICKET_SUCCESS: {
      return {
        ...state,
        sendSupportTicketLoading: false,
        sendSupportTicketSuccess: true,
        error: undefined
      };
    }
    case SEND_SUPPORT_TICKET_FAILURE:
      return {
        ...state,
        sendSupportTicketLoading: false,
        sendSupportTicketSuccess: false,
        error: action.payload
      };
    case RESET_SEND_SUPPORT_TICKET:
      return {
        ...state,
        sendSupportTicketLoading: false,
        sendSupportTicketSuccess: false,
        error: undefined
      };
    default:
      return state;
  }
};
export default supportTicketReducers;
